import HotkeysPreferences from './HotkeysPreferences.tsx';

export default HotkeysPreferences;
